import { PropsWithChildren } from "react"
import { Fade, Paper, paperClasses, Popper, styled, SuggestionsPaper, SxProps } from "@tm/components"
import { useTheme } from "@emotion/react"
import { NextTheme } from "@tm/themes"
import { OptionsGeneric } from "@popperjs/core"

const PopperPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper, // "white",
    padding: 0,
    "&::-webkit-scrollbar-track": {
        background: theme.palette.background.paper, // scrollbar background
    },

    // Firefox Unterstützung
    scrollbarColor: `#888 ${theme.palette.background.paper}`, //

    [`&.${paperClasses.root}`]: {
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: theme.radius.default,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "min-content",
    },
}))

export function Suggestions(
    props: PropsWithChildren<{
        anchor: HTMLElement | null
        isOpen: boolean
        className?: string
        sx?: SxProps
        popperOptions?: Partial<OptionsGeneric<unknown>>
    }>
) {
    const { anchor, isOpen, children, className, popperOptions, sx } = props
    const theme = useTheme() as NextTheme

    const overwriteSx = theme.overwrites?.components?.textfield

    return (
        <Popper open={isOpen} anchorEl={anchor} placement="bottom-start" popperOptions={popperOptions} transition>
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                    <SuggestionsPaper
                        elevation={3}
                        sx={{
                            ...(overwriteSx?.backgroundColor && {
                                backgroundColor: overwriteSx?.backgroundColor,
                                "&::-webkit-scrollbar-track": {
                                    background: overwriteSx?.backgroundColor, // scrollbar background
                                },

                                // Firefox Unterstützung
                                scrollbarColor: `#888 ${overwriteSx?.backgroundColor}`,
                            }),
                            ...sx,
                        }}
                        className={className}
                    >
                        {children}
                    </SuggestionsPaper>
                </Fade>
            )}
        </Popper>
    )
}
